import { useState } from "react";
import FullWidthHeading from "../Device/FullWidthHeading";
import { Button } from "react-bootstrap";
import DemoModal from "../Common/DemoModal";

const AboutPayroll = () => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <div className="about-payrollService">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <FullWidthHeading
                sectionTitle="OUR WORKPLACE"
                title="Nurturing Employee Well-Being & Team Synergy"
                desc="SmartOffice.ai places a premium on employee well-being. It goes beyond 
traditional aspects and extends to the spiritual and psychological upliftment 
of our workforce. We have built a welcoming working environment that 
inspires creativity and innovation. Our commitment to strong team support 
and equitable administrative and management policies ensures that we 
meet the core needs of our employees. Team spirit thrives when team 
members collaborate efficiently, responsibly, and respectfully. We've 
created a psychologically safe atmosphere that accelerates innovation, 
enhances productivity, mitigates risks, and drives superior problem-solving.
">
                <div class="btn-group">
                  <Button
                    to={"#"}
                    className="btn btn-primary radius-8"
                    onClick={() => setModalShow(true)}
                  >
                    Get a demo
                  </Button>
                  <a
                    href="/smart-people/payroll-management"
                    class="btn btn-outline-primary radius-8"
                  >
                    Try it now
                    <span class="tryNow">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.1875 7.03125V2.8125H10.9688"
                          stroke="#243757"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10.125 7.875L15.1875 2.8125"
                          stroke="#243757"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12.9375 10.125V14.625C12.9375 14.7742 12.8782 14.9173 12.7727 15.0227C12.6673 15.1282 12.5242 15.1875 12.375 15.1875H3.375C3.22582 15.1875 3.08274 15.1282 2.97725 15.0227C2.87176 14.9173 2.8125 14.7742 2.8125 14.625V5.625C2.8125 5.47582 2.87176 5.33274 2.97725 5.22725C3.08274 5.12176 3.22582 5.0625 3.375 5.0625H7.875"
                          stroke="#243757"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              </FullWidthHeading>
            </div>
            <div className="col-12 d-block d-lg-none">
              <div className="img">
                <img
                  src={require("./../../assets/images/feature/payroll-mob-laptop.png")}
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DemoModal modalShow={modalShow} setModalShow={setModalShow} />
    </>
  );
};

export default AboutPayroll;
